(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wxt-fabric-navigation"] && !Shopify.designMode) return;
  try {
    class WxtFabricNavigation extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.nav = this.querySelector('.wxtf-floating-nav');
      this.bar = this.querySelector('.wxtf-nav__bar');
      this.toggle = this.querySelector('.wxtf-menu-toggle');
      this.drawer = this.querySelector('.wxtf-nav__drawer');
      this.scrim = this.querySelector('.wxtf-nav__scrim');
      this.items = [...this.querySelectorAll('.wxtf-nav__item')];
      this.hoverCloseTimer = 0;
      this.announcement = document.querySelector('.announcement-bar-section');
      this.onSync = () => this.sync();
      this.toggle.addEventListener('click', () => this.setOpen(this.nav.dataset.open !== 'true'), { signal });
      this.querySelector('.wxtf-close').addEventListener('click', () => this.setOpen(false, true), { signal });
      this.scrim.addEventListener('click', () => this.setOpen(false, true), { signal });
      this.drawer.addEventListener('mouseenter', () => this.cancelHoverClose(), { signal });
      this.drawer.addEventListener('mouseleave', event => {
        if (!matchMedia('(min-width:750px) and (hover:hover)').matches || this.drawer.contains(event.relatedTarget)) return;
        this.scheduleHoverClose(() => {
          if (!this.drawer.matches(':hover')) this.setOpen(false);
        });
      }, { signal });
      this.items.forEach(item => {
        const primary = item.querySelector('.wxtf-nav__primary-link');
        if (!primary.hasAttribute('aria-controls')) return;
        item.addEventListener('mouseenter', () => {
          if (this.nav.dataset.state !== 'collapsed' || !matchMedia('(min-width:750px) and (hover:hover)').matches) return;
          this.cancelHoverClose();
          this.closeSubmenus(item);
          item.classList.add('is-submenu-open');
          primary.setAttribute('aria-expanded', 'true');
        }, { signal });
        item.addEventListener('mouseleave', () => {
          if (!matchMedia('(min-width:750px) and (hover:hover)').matches) return;
          this.scheduleHoverClose(() => {
            if (item.matches(':hover') || item.contains(document.activeElement)) return;
            item.classList.remove('is-submenu-open');
            primary.setAttribute('aria-expanded', 'false');
          });
        }, { signal });
        const submenu = item.querySelector('.wxtf-nav__submenu');
        submenu.addEventListener('mouseenter', () => {
          this.cancelHoverClose();
          item.classList.add('is-submenu-open');
          primary.setAttribute('aria-expanded', 'true');
        }, { signal });
        submenu.addEventListener('mouseleave', () => {
          this.scheduleHoverClose(() => {
            if (item.matches(':hover') || item.contains(document.activeElement)) return;
            item.classList.remove('is-submenu-open');
            primary.setAttribute('aria-expanded', 'false');
          });
        }, { signal });
        item.addEventListener('focusin', () => {
          if (this.nav.dataset.state === 'collapsed' && matchMedia('(min-width:750px)').matches) primary.setAttribute('aria-expanded', 'true');
        }, { signal });
        item.addEventListener('focusout', event => {
          if (!item.contains(event.relatedTarget) && !item.classList.contains('is-submenu-open')) primary.setAttribute('aria-expanded', 'false');
        }, { signal });
      });
      this.drawer.addEventListener('click', event => {
        const link = event.target.closest('a');
        if (!link) return;
        if (link.matches('.wxtf-nav__primary-link[aria-controls]') && this.nav.dataset.state === 'collapsed' && matchMedia('(max-width:749px), (hover:none)').matches) {
          const item = link.closest('.wxtf-nav__item');
          if (!item.classList.contains('is-submenu-open')) {
            event.preventDefault();
            this.closeSubmenus();
            item.classList.add('is-submenu-open');
            link.setAttribute('aria-expanded', 'true');
            return;
          }
        }
        this.setOpen(false);
      }, { signal });
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.nav.dataset.open === 'true') this.setOpen(false, true);
        if (event.key !== 'Tab' || this.nav.dataset.open !== 'true') return;
        const focusable = [...this.drawer.querySelectorAll('a[href], button')].filter(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }, { signal });
      document.addEventListener('scroll', this.onSync, { passive: true, capture: true, signal });
      window.addEventListener('resize', this.onSync, { passive: true, signal });
      window.addEventListener('pageshow', this.onSync, { signal });
      this.lang = this.querySelector('.wxtf-lang');
      if (this.lang) {
        document.addEventListener('click', event => { if (this.lang.open && !this.lang.contains(event.target)) this.lang.open = false; }, { signal });
        document.addEventListener('keydown', event => { if (event.key === 'Escape' && this.lang.open) { this.lang.open = false; this.lang.querySelector('summary').focus(); } }, { signal });
      }
      this.resizeObserver = new ResizeObserver(this.onSync);
      if (this.announcement) this.resizeObserver.observe(this.announcement);
      this.sync();
    }
    cancelHoverClose() {
      clearTimeout(this.hoverCloseTimer);
      this.hoverCloseTimer = 0;
    }
    scheduleHoverClose(callback) {
      this.cancelHoverClose();
      this.hoverCloseTimer = setTimeout(callback, 260);
    }
    closeSubmenus(exceptItem = null) {
      this.items.forEach(item => {
        if (item === exceptItem) return;
        item.classList.remove('is-submenu-open');
        item.querySelector('[aria-controls]')?.setAttribute('aria-expanded', 'false');
      });
    }
    setOpen(open, restoreFocus = false) {
      if (this.nav.dataset.state === 'hero') open = false;
      if (!open) this.cancelHoverClose();
      this.nav.dataset.open = String(open);
      this.dataset.navOpen = String(open);
      this.toggle.setAttribute('aria-expanded', String(open));
      this.scrim.setAttribute('aria-hidden', String(!open));
      this.drawer.inert = this.nav.dataset.state !== 'hero' && !open;
      this.bar.inert = this.nav.dataset.state === 'hero' || open;
      if (!open) this.closeSubmenus();
      if (open) this.querySelector('.wxtf-close').focus({ preventScroll: true });
      else if (restoreFocus && this.nav.dataset.state === 'collapsed') this.toggle.focus({ preventScroll: true });
    }
    sync() {
      const announcementHeight = this.announcement?.offsetHeight || 0;
      const state = this.dataset.home === 'true' && window.scrollY <= 8 ? 'hero' : 'collapsed';
      this.nav.style.setProperty('--wxtf-announcement-height', `${state === 'hero' ? announcementHeight : 0}px`);
      this.scrim.style.setProperty('--wxtf-announcement-height', `${state === 'hero' ? announcementHeight : 0}px`);
      this.dataset.navState = state;
      if (this.nav.dataset.state !== state) {
        this.nav.dataset.state = state;
        this.setOpen(false);
      }
    }
    disconnectedCallback() {
      this.cancelHoverClose();
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
    }
  }
  if (!customElements.get('wxt-fabric-navigation')) customElements.define('wxt-fabric-navigation', WxtFabricNavigation);
  } catch(e) { console.error(e); }
})();

})();
